import React, { useEffect, useState } from "react";
import style from './commentInsight.module.scss';
import Modal from "../Modal/Modal"
import Tab from "./tabComponent/tab";
import { GetComments } from '../../actions/APIcalls'

const CommentInsight = (props) => {

    const [pageDetail, setPageDetail] = useState({
        tabs: [{ title: 'همه پنل‌ها', selected: true }, { title: `پنل شما`, selected: false }],
        page: 1,
        totalPage: 1,
        loading: 0,
        intent_data: [],
        comments: [],
        sellerComments: [],
        ratings: [],
        recommendation_status: {
            recommended: 0,
            no_idea: 0,
            not_recommended: 0,
        },
        sellers_recommendation_status: {
            recommended: 0,
            no_idea: 0,
            not_recommended: 0,
        },
        allRecommendations: 0,
        allSellersRecommendations: 0
    })

    useEffect(() => {
        if (props.data.dkp && props.data.name) {
            getComments()
        } else {
            resetComments()
        }
    }, [props.data])

    const resetComments = () => {
        setPageDetail({
            ...pageDetail,
            tabs: [{ title: 'همه پنل‌ها', selected: true }, { title: `پنل شما`, selected: false }],
            page: 1,
            totalPage: 1,
            loading: 0,
            intent_data: [],
            comments: [],
            sellerComments: [],
            ratings: [],
            recommendation_status: {
                recommended: 0,
                no_idea: 0,
                not_recommended: 0,
            },
            sellers_recommendation_status: {
                recommended: 0,
                no_idea: 0,
                not_recommended: 0,
            },
            allRecommendations: 0,
            allSellersRecommendations: 0
        })
    }

    const getComments = async () => {
        let res = await commentsFunction()
        if (res.success) {
            while ((pageDetail.totalPage != pageDetail.page) && pageDetail.page < 100) {
                setPageDetail({ ...pageDetail, page: ++pageDetail.page, loading: ((100 * pageDetail.page) / (pageDetail.totalPage > 100 ? 100 : pageDetail.totalPage)) })
                await commentsFunction()
                await setSellersInfo(((pageDetail.page - 1) * 20), pageDetail.comments.length)
            }
            setPageDetail({ ...pageDetail, loading: 100 })
        }
    }

    const commentsFunction = async () => {
        let result = { success: true }
        let res = await GetComments({ dkp: props.data.dkp, page: pageDetail.page })
        let tmp = pageDetail
        if (res && res.data && res.data.data && res.data.data.comments.length > 0) {
            tmp.comments = pageDetail.comments.concat(res.data.data.comments)
            tmp.totalPage = res.data.data.pager.total_pages
            if ((pageDetail.totalPage == pageDetail.page) || pageDetail.page >= 100) {
                tmp.intent_data = res.data.data.intent_data
            }
            if (res.data.data.ratings) {
                tmp.ratings = res.data.data.ratings
            }
            res.data.data.comments.map(el => {
                if (el.recommendation_status) {
                    tmp.recommendation_status[el.recommendation_status] += 1
                    tmp.allRecommendations += 1
                }
            })
        } else {
            result.success = false
        }
        setPageDetail({ ...tmp })
        return result
    }

    const setSellersInfo = async (firstItem, lastItem) => {
        let sellerCommentsTmp = []
        let tmpPageDetails = pageDetail
        for (let index = firstItem; index < lastItem; index++) {
            const element = tmpPageDetails.comments[index];
            if (element.purchased_item && element.purchased_item.seller && element.purchased_item.seller.title && element.purchased_item.seller.title == props.data.channelName) {
                sellerCommentsTmp.push(element)
                if (element.recommendation_status) {
                    tmpPageDetails.sellers_recommendation_status[element.recommendation_status] += 1
                    tmpPageDetails.allSellersRecommendations += 1
                }
            }
        }
        tmpPageDetails.sellerComments = pageDetail.sellerComments.concat(sellerCommentsTmp)
        setPageDetail({ ...tmpPageDetails })
    }

    const changeTab = tab => {
        let tmpData = pageDetail
        tmpData.tabs.map(el => el.selected = false)
        tmpData.tabs[tab].selected = true
        setPageDetail({ ...tmpData })
    }

    return (
        <>
            <Modal
                value={props.value}
                title={props.title}
                tooltip={'دیدگاه‌های موجود در سایت، یکی از مهم ترین منابع تصمیم‌گیری خرید مشتریان در مارکت‌پلیس‌ها می‌باشد. با بررسی دیدگاه‌های موجود و مقایسه بین دیدگاه‌های فروشندگان دیگر و دیدگاه‌های محصولات خودتان، می‌توانید به بهبود عملکرد‌تان کمک کنید و یا به علت ضعف‌تان پی برده و آن‌را اصلاح کنید.'}
                parentClose={props.parentClose}
            >
                {pageDetail.comments.length > 0 ?
                    <div className={style.wrapper}>
                        {/* Tabs */}
                        <div className={style.tabFlexBox}>
                            {pageDetail.tabs.map((tab, tabIndex) => <div
                                key={tabIndex}
                                className={pageDetail.tabs[tabIndex].selected == true ? style.tabFlexItemActive : style.tabFlexItem}
                                onClick={() => changeTab(tabIndex)}
                            >
                                {tab.title}
                            </div>)}
                        </div>
                        {/* Sellers' Comments Insight */}
                        {pageDetail.sellerComments.length > 0 && pageDetail.tabs[1].selected == true && <>
                            <p className={style.recommendedTitle}>دیدگاه‌های پنل {props.data.channelName}</p>
                            <Tab
                                tag='seller'
                                recommendation_status={pageDetail.sellers_recommendation_status}
                                allRecommendations={pageDetail.allSellersRecommendations}
                                comments={pageDetail.sellerComments}
                                aiInsights={false}
                            />
                        </>}

                        {/* All Comments Insight */}
                        {pageDetail.comments.length > 0 && pageDetail.tabs[0].selected == true && <>
                            <p className={style.recommendedTitle}>تمام دیدگاه‌ها</p>
                            <Tab
                                tag='all'
                                recommendation_status={pageDetail.recommendation_status}
                                allRecommendations={pageDetail.allRecommendations}
                                comments={pageDetail.comments}
                                aiInsights={pageDetail.intent_data.length > 0 ? pageDetail.intent_data : false}
                            />
                        </>}

                        {/* When there's no comments for seller */}
                        {pageDetail.tabs[1].selected == true && pageDetail.sellerComments.length == 0 && <p className={style.emptySellerComments}>متاسفانه دیدگاهی برای پنل <b>{props.data.channelName}</b> ثبت نشده است.</p>}

                        {pageDetail.loading > 0 && pageDetail.loading < 100 && <div className={style.loading}><div className={style.thumb} style={{ width: `${pageDetail.loading}%` }}></div></div>}
                    </div>
                    :
                    <div className={style.emptyState}>
                        <p>متاسفانه دیدگاهی برای این محصول ثبت نشده است.</p>
                    </div>
                }
            </Modal>
        </>
    )

}
export default CommentInsight